import { EventsManager, WinEvents } from "../../../abstracts/events/EventsManager";
import { AbstractModuleController } from "../../../abstracts/modules/AbstractModuleController";
import { DDDWinView } from "./DDDWinView";

export class DDDWinController extends AbstractModuleController {
    public get name(): string {
        return `DDDWinController`;
    }

    public get view(): DDDWinView {
        if (this._view === undefined || this._view === null) {
            this._view = new DDDWinView();
        }
        return this._view as DDDWinView;
    }

    protected handleEvents() {
        super.handleEvents();

        EventsManager.trigger(WinEvents.GET_WINNINGS_VIEW, this.view);
    }
}
